import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import {
  CHAT_GRADIENT_END,
  CHAT_GRADIENT_MIDDLE,
  CHAT_GRADIENT_START,
  CHAT_ON_GRADIENT,
} from '../chatColors'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    background: `linear-gradient(139.14deg, ${CHAT_GRADIENT_START} 0%, ${CHAT_GRADIENT_MIDDLE} 61.61%, ${CHAT_GRADIENT_END} 111.43%)`,
    padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    flexShrink: 0,
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  leftGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  branding: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    minWidth: 0,
  },
  brandMark: {
    width: theme.spacing(3),
    height: theme.spacing(2.25),
    flexShrink: 0,
  },
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  title: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: CHAT_ON_GRADIENT,
    whiteSpace: 'nowrap',
  },
  subtitle: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16px',
    color: CHAT_ON_GRADIENT,
    opacity: 0.8,
    whiteSpace: 'nowrap',
  },
}))
